import { render, staticRenderFns } from "./BetalockQuiz.vue?vue&type=template&id=70054b84&scoped=true"
import script from "./BetalockQuiz.vue?vue&type=script&lang=js"
export * from "./BetalockQuiz.vue?vue&type=script&lang=js"
import style0 from "./BetalockQuiz.vue?vue&type=style&index=0&id=70054b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70054b84",
  null
  
)

export default component.exports